export const TEMPLATE_TYPE = 'landing-page';
